/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { UserCatalogDto } from './UserCatalogDto';
import {
    instanceOfUserCatalogDto,
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * @type BeamConstancyWorkResultDtoCreatorUser
 * 
 * @export
 */
export type BeamConstancyWorkResultDtoCreatorUser = UserCatalogDto;


export function BeamConstancyWorkResultDtoCreatorUserFromJSON(json: any): BeamConstancyWorkResultDtoCreatorUser {
    return BeamConstancyWorkResultDtoCreatorUserFromJSONTyped(json, false);
}

export function BeamConstancyWorkResultDtoCreatorUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkResultDtoCreatorUser {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...UserCatalogDtoFromJSONTyped(json, true) };
    return  UserCatalogDtoFromJSONTyped(json, true);
}

export function BeamConstancyWorkResultDtoCreatorUserToJSON(value?: BeamConstancyWorkResultDtoCreatorUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfUserCatalogDto(value)) {
        return UserCatalogDtoToJSON(value as UserCatalogDto);
    }

    return {};
}

/**
 * Check if a given object implements the BeamConstancyWorkResultDtoCreatorUser interface.
 */
export function instanceOfBeamConstancyWorkResultDtoCreatorUser(value: any): value is BeamConstancyWorkResultDtoCreatorUser {
    if (instanceOfUserCatalogDto(value)) return true;
    return false;
}

